import {observeUsers} from "./User.repository";
import {useObserverState} from "../app/data/State.hooks";

export const useUsers = () => useObserverState(observeUsers(), []);
